import useEvent from '@lyearn/core/hooks/useEvent';
import ENPSRating, { DEFAULT_RATING_SIZE } from '@/modules/user-survey/components/ENPSRating';
import useQuestionPlayerResponse from '@/modules/user-survey/hooks/useQuestionPlayerResponse';
import QuestionPlayerContainer from '@/modules/user-survey/questions/components/QuestionPlayerContainer';
import { QuestionPlayerProps } from '@/modules/user-survey/questions/types';
import { QuestionTypeEnum } from '@/types/schema';

const RatingQuestionPlayer = (props: QuestionPlayerProps) => {
  const {
    variant,
    question,
    userSurveyQuestionSettings,
    error,
    useRichTextForComment,
    response,
    onChange,
    commentTitle,
    disabled,
    requireComments,
  } = props;
  const actions = useQuestionPlayerResponse({ response, onChange });

  const onValueChange = useEvent((ratingResponse: number) => {
    if (disabled) {
      return;
    }

    // FIX: SurveyResponseInput and QuestionReviewResponseInput are different.
    actions.onQuestionResponseChange({
      responseType: QuestionTypeEnum.Rating,
      ratingResponse: {
        value: ratingResponse,
        scale: question.settings?.ratingScale ?? DEFAULT_RATING_SIZE,
      },
    } as any);
  });

  return (
    <QuestionPlayerContainer
      commentTitle={commentTitle}
      disabled={disabled}
      error={error}
      post={response?.post}
      question={question}
      requireComments={requireComments}
      useRichTextForComment={useRichTextForComment}
      userSurveyQuestionSettings={userSurveyQuestionSettings}
      variant={variant}
      onPostChange={actions.onPostChange}>
      <ENPSRating
        className={variant === 'form' ? 'mt-16 py-4' : 'mt-32 py-16'}
        ratingScale={question.settings?.ratingScale ?? undefined}
        // FIX: SurveyResponseInput and QuestionReviewResponseInput are different.
        value={(response?.questionSurveyResponse as any)?.ratingResponse.value}
        onChange={onValueChange}
      />
    </QuestionPlayerContainer>
  );
};

export default RatingQuestionPlayer;
